/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import { WebMercatorViewport } from 'viewport-mercator-project'
export type MapGlContextProps = {
  viewport?: WebMercatorViewport

  map: any
  container: null | HTMLDivElement

  onViewStateChange?: Function
  onViewportChange?: Function

  isDragging: boolean
  eventManager: any
}

export const MapGlContext = React.createContext<MapGlContextProps>({
  viewport: {} as any,
  map: {} as any,
  container: null,
  onViewStateChange: () => {},
  onViewportChange: () => {},
  isDragging: false,
  eventManager: {} as any,
})

export type MapGlContextProvider = Function
